import React, { useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { orbitNodes } from '../../data/modalities';
export function ModalityOrbit() {
  const [active, setActive] = useState(0);
  const shouldReduceMotion = useReducedMotion();
  const size = 560;
  const center = size / 2;
  const radius = 220;
  const positions = orbitNodes.map((_, index) => {
    const angle = index / orbitNodes.length * Math.PI * 2 - Math.PI / 2;
    return {
      x: center + radius * Math.cos(angle),
      y: center + radius * Math.sin(angle)
    };
  });
  return <div className="relative mx-auto" style={{
    width: size,
    height: size,
    maxWidth: '100%'
  }} data-id="element-119" data-mp="270r0gbmxp89f">
      <svg viewBox={`0 0 ${size} ${size}`} className="absolute inset-0 h-full w-full" aria-hidden="true" data-id="element-120" data-mp="2g3088tqtinj4">
        {[0.34, 0.62, 1].map(ring => <circle key={ring} cx={center} cy={center} r={radius * ring} fill="none" stroke="#33a7b5" strokeOpacity={0.14} strokeWidth={1} data-id="element-121" data-mp="1occe41nkaiey" />)}
        {positions.map((position, index) => {
        const isActive = index === active;
        return <motion.line key={orbitNodes[index].id} x1={center} y1={center} x2={position.x} y2={position.y} stroke="#33a7b5" initial={false} animate={{
          strokeOpacity: isActive ? 0.9 : 0.16,
          strokeWidth: isActive ? 2.5 : 1
        }} transition={{
          duration: shouldReduceMotion ? 0 : 0.25
        }} data-id="element-122" data-mp="15piamrrxtlnm" data-mpi={index} />;
      })}
      </svg>

      <div className="absolute left-1/2 top-1/2 flex h-[176px] w-[176px] -translate-x-1/2 -translate-y-1/2 flex-col items-center justify-center rounded-full bg-navy px-7 py-5 text-center shadow-2xl shadow-navy/30" data-id="element-123" data-mp="rto2iayzn0bk">
        <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-teal-light" data-id="element-124" data-mp="38y0et0kvoxi">
          JAG Medical Solutions
        </p>
        <motion.p key={active} initial={shouldReduceMotion ? false : {
        opacity: 0,
        y: 4
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: shouldReduceMotion ? 0 : 0.2
      }} className="mt-1.5 max-w-[144px] break-words font-display text-[15px] font-extrabold leading-[1.1] text-white" data-id="element-125" data-mp="3ue6727924546">
          {orbitNodes[active].name}
        </motion.p>
        <motion.p key={`detail-${active}`} initial={shouldReduceMotion ? false : {
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: shouldReduceMotion ? 0 : 0.25
      }} className="mt-1.5 max-w-[142px] text-[11px] leading-[1.25] text-white/70" data-id="element-126" data-mp="3bpstjgrkpuye">
          {orbitNodes[active].detail}
        </motion.p>
      </div>

      {positions.map((position, index) => {
      const node = orbitNodes[index];
      const isActive = index === active;
      return <div key={node.id} className="absolute" style={{
        left: position.x,
        top: position.y,
        transform: 'translate(-50%, -50%)'
      }} data-id="element-127" data-mp="2it0gsg67m4ru" data-mpi={index}>
            {isActive && <motion.span className="pointer-events-none absolute inset-0 rounded-full border-2 border-teal/60" initial={false} animate={shouldReduceMotion ? {
          opacity: 0.3,
          scale: 1.08
        } : {
          opacity: [0.38, 0, 0.38],
          scale: [1, 1.18, 1]
        }} transition={shouldReduceMotion ? {
          duration: 0
        } : {
          duration: 2.8,
          ease: 'easeInOut',
          repeat: Infinity
        }} data-id="element-128" data-mp="2dwa0brqht75w" />}
            <motion.button type="button" onMouseEnter={() => setActive(index)} onFocus={() => setActive(index)} onClick={() => setActive(index)} initial={false} animate={{
          scale: isActive ? 1.035 : 1,
          y: 0
        }} whileHover={shouldReduceMotion ? undefined : {
          scale: 1.045,
          y: -3
        }} whileTap={shouldReduceMotion ? undefined : {
          scale: 0.98
        }} transition={{
          type: 'spring',
          stiffness: 320,
          damping: 24
        }} className={`relative flex h-[90px] w-[90px] cursor-pointer flex-col items-center justify-center rounded-full border-2 px-2 text-center outline-none transition-[background-color,border-color,box-shadow] duration-200 focus-visible:ring-[3px] focus-visible:ring-navy focus-visible:ring-offset-4 focus-visible:ring-offset-white ${isActive ? 'z-10 border-teal-light bg-teal text-white shadow-[0_16px_30px_-12px_rgba(51,167,181,0.85)]' : 'border-transparent bg-white text-navy shadow-[0_10px_22px_-14px_rgba(26,27,75,0.4)] hover:border-teal/70 hover:bg-slate-50 hover:shadow-[0_16px_28px_-12px_rgba(51,167,181,0.45)]'}`} aria-label={node.name} aria-pressed={isActive} data-id="element-129" data-mp="1l6t9gyiitybs">
              <span className={`max-w-[76px] break-words leading-[1.08] ${isActive ? 'text-[12px] font-extrabold' : 'text-[11px] font-bold'}`} data-id="element-130" data-mp="3fkm4bown46j5">
                {node.name}
              </span>
            </motion.button>
          </div>;
    })}
    </div>;
}